import { Dispatch } from "react";

import { useTranslation } from "@/lib/i18n";
import { WidgetTypes } from "@/types/widget";
import Button from "@/components/button/button";
import Stack from "@/components/stack/stack";
import { Icon, IconNames } from "@/components/icon/icon";
import DialogHeader from "@/components/dialog/dailog-header";
import Dialog from "@/components/dialog/dialog";
import dialogVariants from "@/components/dialog/dialog-variants.module.css";

import styles from "./pick-widget-type-dialog.module.css";

const icons: Record<WidgetTypes, IconNames> = {
  map: "map",
  rich_text: "type-outline",
  line_graph: "line-chart",
  opmet_report: "table",
  early_warning_table: "rainfall",
  legacy: "bean",
  observations_map: "map",
  model_map: "map",
  maritime_broadcast: "waves",
  maritime_forecast: "waves",
  maritime_seiches: "waves",
  time_series: "line-chart",
};

export function PickWidgetType({
  setWidgetType,
}: {
  setWidgetType: Dispatch<WidgetTypes>;
}) {
  const { t } = useTranslation();
  return (
    <div className={styles.options}>
      {Object.values(WidgetTypes).map((widgetType) => (
        <Button
          variant="card"
          key={widgetType}
          className={styles.button}
          onClick={() => setWidgetType(widgetType)}
        >
          <Stack flexDirection="column" alignItems="center">
            <Icon name={icons[widgetType] ?? "bolt"} size={48} />
            <div className={styles.buttonLabel}>
              {t(`admin.widgets.types.${widgetType}`)}
            </div>
          </Stack>
        </Button>
      ))}
    </div>
  );
}

export interface PickWidgetDialogProps {
  open: boolean;
  onOpenChange: Dispatch<boolean>;
  onPick: Dispatch<WidgetTypes>;
}

export function PickWidgetDialog({ open, onOpenChange, onPick }: PickWidgetDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content className={dialogVariants.default}>
        <DialogHeader title={t("admin.widgets.select_widget_type")} />
        <PickWidgetType setWidgetType={onPick} />
      </Dialog.Content>
    </Dialog>
  );
}
